import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {Message} from '../value-object/message';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {
  public readonly messages: Observable<Message[]>;
  private readonly _messages = new BehaviorSubject<Message[]>([]);

  public constructor() {
    this.messages = this._messages.asObservable();
  }

  public addMessage(message: Message): void {
    this._messages.next([...this._messages.getValue(), message]);
  }

  public clearMessages(): void {
    this._messages.next([]);
  }
}
